import { render, staticRenderFns } from "./EditFrame.vue?vue&type=template&id=3e522cf7&scoped=true"
import script from "./EditFrame.vue?vue&type=script&lang=ts"
export * from "./EditFrame.vue?vue&type=script&lang=ts"
import style0 from "./EditFrame.vue?vue&type=style&index=0&id=3e522cf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e522cf7",
  null
  
)

export default component.exports